import DuckEntity from './DuckEntity';
import {billingAccounts} from "./index";
import {customDuck} from 'utils/duckify';

import { apiFetch, apiAction } from 'utils';


const billingPayments = new DuckEntity('billingPayments');

const aliasByBillingAccount = (billing_account_id) => `billingAccount(${billing_account_id}).billing_payment`;

const readByBillingAccount = (state, billing_account_id) => billingPayments.single(state, aliasByBillingAccount(billing_account_id));

const getByBillingAccount = (billing_account_id) => apiAction(
  billingPayments.actions.GET_BEGIN, billingPayments.actions.GET_SUCCESS, billingPayments.actions.GET_ERROR,
  (state) => apiFetch.get(state, `${billingAccounts.config.entityApiPath(billing_account_id)}/billing_payment`, billingPayments.config.loadOptions),
  {
    entityName: billingPayments.config.name,
    id: aliasByBillingAccount(billing_account_id)
  },
  {[billingPayments.config.jsonRoot]: billingPayments.config.schema}
);

export const entity = {
  ...billingPayments,
  byBillingAccount: (billing_account_id) => customDuck(billingPayments, {
    load: () => getByBillingAccount(billing_account_id),
    read: (state) => readByBillingAccount(state, billing_account_id)
  })
};
